import { render, staticRenderFns } from "./BroadSheetBySubjects.vue?vue&type=template&id=6f2f4b41&scoped=true&"
import script from "./BroadSheetBySubjects.vue?vue&type=script&lang=js&"
export * from "./BroadSheetBySubjects.vue?vue&type=script&lang=js&"
import style0 from "./BroadSheetBySubjects.vue?vue&type=style&index=0&id=6f2f4b41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f4b41",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VCol,VRow,VSimpleTable})
